import HeaderNotification from './components/HeaderNotification';
import MobileNav from './components/MobileNav';
import Overlays from './components/Overlays';
import HeaderMenu from './components/HeaderMenu';
import HeroSlider from './components/HeroSlider';
import DevelopmentsListings from './components/DevelopmentsListings';
import ExpandList from './components/ExpandList';
import Expanders from './components/Expanders';
import CarouselVideo from './components/CarouselVideo';
import FormSwitcher from './components/FormSwitcher';
import GLightbox from 'glightbox'
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';

import 'alpinejs';

const gallery = document.querySelectorAll('[data-gallery-btn]');

gallery.forEach(element => {
    let galleryElements = JSON.parse(element.dataset.elements);

    const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        elements: galleryElements
    });    

    element.addEventListener('click', (e) => {
        lightbox.open();
    });
});

new MobileNav;
new HeaderNotification;
new Overlays;
new HeaderMenu;
new HeroSlider;
new DevelopmentsListings;
new ExpandList;
new Expanders;
new CarouselVideo;
new FormSwitcher;